import { Link } from "react-router-dom";

const stats = [
  { value: "12+", label: "Years in Vegas" },
  { value: "4", label: "European Stylists" },
  { value: "400+", label: "5-Star Reviews" },
  { value: "98%", label: "Client Return Rate" },
];

export default function AboutUs() {
  return (
    <section className="w-full bg-white py-24 px-6" id="about">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div className="relative">
          <div className="w-full h-[520px] rounded-lg overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/3e2d1d2c543c3887641aa4a0f519c922.jpg"
              alt="VegasGlamHair salon interior"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute -bottom-6 -right-6 bg-[#C9A96E] text-white p-8 rounded-lg hidden lg:block">
            <p className="text-4xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>12+</p>
            <p className="text-sm tracking-widest uppercase mt-1 text-white/80">Years of Glamour</p>
          </div>
        </div>
        <div>
          <span className="text-[#C9A96E] text-xs font-semibold tracking-[0.3em] uppercase mb-4 block">Our Story</span>
          <h2 className="text-neutral-900 text-3xl md:text-5xl font-bold leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            European Mastery,<br />Vegas Soul
          </h2>
          <p className="text-neutral-500 text-sm leading-relaxed mb-5">
            Founded by European-trained stylists who fell in love with the energy of Las Vegas, VegasGlamHair was built on one belief: every client deserves couture-level hair. We brought the precision, artistry, and education of the Paris and Milan salon world to the heart of the Strip.
          </p>
          <p className="text-neutral-500 text-sm leading-relaxed mb-8">
            Our team trains continuously with the latest European techniques — from lived-in balayage to precision architectural cuts — ensuring that every chair, every appointment, and every client is treated with the highest standard of craft.
          </p>
          <div className="grid grid-cols-2 gap-6 mb-10">
            {stats.map((s) => (
              <div key={s.label} className="border-l-2 border-[#C9A96E] pl-4">
                <p className="text-2xl font-bold text-neutral-900" style={{ fontFamily: "'Playfair Display', serif" }}>{s.value}</p>
                <p className="text-neutral-400 text-xs tracking-widest uppercase mt-0.5">{s.label}</p>
              </div>
            ))}
          </div>
          <Link to="/team" className="inline-block bg-[#C9A96E] text-white text-sm font-semibold tracking-widest uppercase px-10 py-4 rounded-sm hover:bg-[#b8934f] transition-colors cursor-pointer whitespace-nowrap">
            Meet Our Team
          </Link>
        </div>
      </div>
    </section>
  );
}
